import React, { } from 'react'
import { useField } from 'formik'

import Input from '../../utils/Input'
import Label from '../../utils/Label'
import RequestFormValidationError from './ValidationError'

export const RequestFormStep4 = () => {
  const [field] = useField('email')

  return (
    <div className="w-full md:w-1/2">
      <Label>Email Address</Label>
      <Input {...field} />
      <RequestFormValidationError name='email' />
    </div>
  )
}
export default RequestFormStep4
